var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-print showOnlyDev"},[_c('v-btn',{attrs:{"icon":"","color":"black","elevation":"0","outlined":"","title":"edit"},on:{"click":function($event){return _vm.edit()}}},[_c('v-icon',[_vm._v("mdi-file-edit")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }